import Axios from 'axios';

const RESOURCE = '/onesearch'

const DEALER_ADS = '/dealer-ads'

export default {
    search: {
        dealerAds(sellerId) {
          return Axios.get(`${RESOURCE}${DEALER_ADS}/${sellerId}`);
        }
    }
};